import { withPath } from "library/api/api";
import { postHref, putHref } from "library/api/httpMethods";
import { mappingRegistrationAPIHttpError } from "./mappingRegistrationAPIHttpError";

// signUp a user in okta via api
export const postSignUp = async ({ firstName, id, password }) => {
  const data = {
    profile: {
      first_name: firstName,
      email: id,
    },
    credentials: {
      password: {
        value: password,
      },
    },
  };
  return postHref<void>(withPath(`v1/users`), data).catch((e) => {
    throw mappingRegistrationAPIHttpError(e);
  });
};

export type PostResendOTP = {
  id: string;
  action: string;
  factorType: string;
};
// resend otp to user
// default action is for registration, support actions are: registration, recovery
// default factor type is email, and it is the only supported value for now
export const postResendOTP = async ({
  id,
  action = "registration",
  factorType = "email",
}) => {
  const data = {
    factor_type: factorType,
    profile: {
      email: id,
    },
  };
  return postHref(withPath(`v1/users/otp/resend?action=${action}`), data).catch(
    (e) => {
      throw mappingRegistrationAPIHttpError(e);
    },
  );
};

export type PostConfirmSignUp = {
  id: string;
  passCode: string;
  factorType?: "email" | "mobile";
};
export type PostConfirmSignUpResponse = {
  activation_token: string;
};
// confirm user sign up by verifying otp code
// default factor type is email, and it is the only supported value for now
export const postConfirmSignUp = async ({
  id,
  passCode,
  factorType = "email",
}: PostConfirmSignUp) => {
  const data = {
    factor_type: factorType,
    pass_code: passCode,
    profile: { email: id },
  };
  return postHref<PostConfirmSignUpResponse>(
    withPath(`v1/users/activate`),
    data,
  ).catch((e) => {
    throw mappingRegistrationAPIHttpError(e);
  });
};

// trigger password recovery process and send user email otp
// default factor type is email, and it is the only supported value for now
export const postPasswordRecovery = async ({ id, factorType = "email" }) => {
  const data = {
    factor_type: factorType,
    profile: {
      email: id,
    },
  };

  return postHref(withPath(`v1/users/recovery`), data).catch((e) => {
    throw mappingRegistrationAPIHttpError(e);
  });
};

// verify user's email otp and reset the new password
// default factor type is email, and it is the only supported value for now
export const putPasswordRecovery = async ({
  passCode,
  newPassword,
  id,
  factorType = "email",
}) => {
  const data = {
    pass_code: passCode,
    credentials: {
      password: {
        value: newPassword,
      },
    },
    factor_type: factorType,
    profile: {
      email: id,
    },
  };

  return putHref(withPath(`v1/users/recovery`), data).catch((e) => {
    throw mappingRegistrationAPIHttpError(e);
  });
};
